/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Register_TitleInputs */

const en_auth_register_title = /** @type {(inputs: Auth_Register_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Up`)
};

const es_auth_register_title = /** @type {(inputs: Auth_Register_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrarse`)
};

/**
* | output |
* | --- |
* | "Sign Up" |
*
* @param {Auth_Register_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_register_title = /** @type {((inputs?: Auth_Register_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Register_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_register_title(inputs)
	return es_auth_register_title(inputs)
});